const BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

const getToken = () => localStorage.getItem("token");

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "發生錯誤");
  return data;
}

// ── 會員 ──
export const auth = {
  register: (body) => request("/api/auth/register", { method: "POST", body: JSON.stringify(body) }),
  login:    (body) => request("/api/auth/login",    { method: "POST", body: JSON.stringify(body) }),
  logout:   ()     => request("/api/auth/logout",   { method: "POST" }),
  me:       ()     => request("/api/auth/me"),
};

// ── 教練 ──
export const coaches = {
  list:             ()                    => request("/api/coaches"),
  get:              (id)                  => request(`/api/coaches/${id}`),
  available:        (date, package_id)    => request(`/api/coaches/available?date=${date}&package_id=${package_id}`),
  // 教練後台
  getMe:            ()                    => request("/api/coaches/me"),
  updateMe:         (body)                => request("/api/coaches/me", { method: "PATCH", body: JSON.stringify(body) }),
  getMyBookings:    ()                    => request("/api/coaches/me/bookings"),
  getMyStats:       ()                    => request("/api/coaches/me/stats"),
  getMyLeaves:      ()                    => request("/api/coaches/me/leaves"),
  addLeave:         (body)                => request("/api/coaches/me/leaves", { method: "POST", body: JSON.stringify(body) }),
  deleteLeave:      (id)                  => request(`/api/coaches/me/leaves/${id}`, { method: "DELETE" }),
  // 舊時段 API（保留相容）
  availability:     (id, date)            => request(`/api/coaches/${id}/availability${date ? `?date=${date}` : ""}`),
  addSlot:          (id, body)            => request(`/api/coaches/${id}/availability`, { method: "POST", body: JSON.stringify(body) }),
  deleteSlot:       (coachId, slotId)     => request(`/api/coaches/${coachId}/availability/${slotId}`, { method: "DELETE" }),
};

// ── 課程方案 ──
export const packages = {
  list: () => request("/api/packages"),
};

// ── 預約 ──
export const bookings = {
  create: (body) => request("/api/bookings", { method: "POST", body: JSON.stringify(body) }),
  list:   ()     => request("/api/bookings"),
  cancel: (id)   => request(`/api/bookings/${id}/cancel`, { method: "PATCH" }),
};

// ── 付款 ──
export const payments = {
  createSession: (booking_id) => request("/api/payments/create-session", {
    method: "POST",
    body: JSON.stringify({ booking_id }),
  }),
  getStatus: (booking_id) => request(`/api/payments/booking/${booking_id}`),
};

// ── 上傳 ──
export const upload = {
  avatar: async (file) => {
    const token = getToken();
    const formData = new FormData();
    formData.append("avatar", file);
    const res = await fetch(`${BASE}/api/upload/avatar`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "上傳失敗");
    return data;
  },
};

// ── 管理員 ──
export const admin = {
  // 用戶
  getUsers:          ()        => request("/api/admin/users"),
  toggleUser:        (id)      => request(`/api/admin/users/${id}/toggle-active`, { method: "PATCH" }),
  resetPassword:     (id, pw)  => request(`/api/admin/users/${id}/password`, { method: "PATCH", body: JSON.stringify({ password: pw }) }),
  verifyEmail:       (id)      => request(`/api/admin/users/${id}/verify-email`, { method: "PATCH" }),
  // 教練
  getCoaches:        ()        => request("/api/admin/coaches"),
  addCoach:          (body)    => request("/api/admin/coaches", { method: "POST", body: JSON.stringify(body) }),
  toggleCoach:       (id)      => request(`/api/admin/coaches/${id}/toggle-active`, { method: "PATCH" }),
  updateCoach:       (id, body)=> request(`/api/admin/coaches/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  // 請假
  getLeaves:         (date)    => request(`/api/admin/coaches/leaves${date ? `?date=${date}` : ""}`),
  addLeave:          (body)    => request("/api/admin/coaches/leaves", { method: "POST", body: JSON.stringify(body) }),
  deleteLeave:       (id)      => request(`/api/admin/coaches/leaves/${id}`, { method: "DELETE" }),
  // 課程方案
  getPackages:       ()        => request("/api/admin/packages"),
  updatePackage:     (id, body)=> request(`/api/admin/packages/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  // 預約
  getBookings:       (status)  => request(`/api/admin/bookings${status ? `?status=${status}` : ""}`),
  assignCoach:       (id, coach_id) => request(`/api/admin/bookings/${id}/assign-coach`, { method: "PATCH", body: JSON.stringify({ coach_id }) }),
  forceCancel:       (id, body)=> request(`/api/admin/bookings/${id}/force-cancel`, { method: "PATCH", body: JSON.stringify(body) }),
  completeBooking:   (id)      => request(`/api/admin/bookings/${id}/complete`, { method: "PATCH" }),
  // 通知
  getPendingBookings: ()       => request("/api/admin/notifications/pending"),
  // 排班
  getSchedule:       (start, end) => request(`/api/admin/schedule?start_date=${start}&end_date=${end}`),
  // 金流
  getRevenue:        ()        => request("/api/admin/revenue"),
  refund:            (id)      => request(`/api/admin/refund/${id}`, { method: "POST" }),
  // 地點
  getLocations:      ()        => request("/api/admin/locations"),
  addLocation:       (body)    => request("/api/admin/locations", { method: "POST", body: JSON.stringify(body) }),
  toggleLocation:    (id)      => request(`/api/admin/locations/${id}/toggle-active`, { method: "PATCH" }),
};